// Main Scripts
// ---------------------
import ticketButton from './js/widgets/ticketButton.js';

import mainSlideshowConcept2 from './js/widgets/mainSlideshowConcept2.js';
import circleCards from './js/widgets/circleCards.js';

import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';

import multiScheduleFeatureConcept2 from './js/widgets/multiScheduleFeatureConcept2.js';
import squareCards from './js/widgets/squareCards.js';

import staticManagedSponsors from './js/widgets/staticManagedSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

$(document).ready(function () {
  ticketButton();

  if (window.location.pathname === '/') {
    mainSlideshowConcept2();
    circleCards();
    seoWidget();

    $(window).load(function () {
      videoWidget();
    });

    multiScheduleFeatureConcept2();
    squareCards();
    staticManagedSponsors();
    scrollerSponsors();
  }
});
